export enum LanguageCodeEnum {
    Danish = "da",
    English = "en"
}
